import { observer, inject } from 'mobx-react';
import * as React from 'react';
import { Store } from '../index';
import { Intent, Spinner } from '@blueprintjs/core/dist';
import { randomUUID } from '../../../utils/uuid';
import { Registration } from '../services/Registration';

const AdminPageComponent = observer((props: { store: typeof Store.Type }) => (
  <div className="cover bg-left bg-center-l a vh-100">
    <div className="mw9 center ph3-ns">
      <div className="cf ph2-ns">
        <div className="pa2">
          <h1>Registrations</h1>
        </div>
        {props.store!.registrations.state === 'pending' ?
          <Spinner className="pt-large measure center" intent={Intent.PRIMARY} /> :
          props.store!.registrations.state === 'error' ?
            <div>error....</div> :
            <ul className="list pointer pl0 mt0 w-100">
              {props.store!.registrations.list.map(r => r as {} as typeof Registration.Type).map(registration => (
                <li
                  id={randomUUID()}
                  className="flex items-center lh-copy pa2-ns ph0-l ba b--black-10 hover-bg-light-gray"
                >
                  <div className="pl2 w-25-ns">
                    <span className="f5 ttu b tracked">{registration.name}</span>
                    {registration.specialty ?
                      <span className="f6 db black-80">
                        <b>Specialty: </b>{registration.specialty}</span> : undefined}
                    {registration.institution ?
                      <span className="f6 db black-80">
                        <b>Institution: </b>{registration.institution}</span> : undefined}
                    {registration.mobile ?
                      <span className="f6 db black-80">
                        <b>Mobile: </b>{registration.mobile}</span> : undefined}
                  </div>
                  <div className="pl2 w-25-ns">
                    {registration.email ?
                      <span className="f6 db black-80"><b>Email: </b>{registration.email}</span> : undefined}
                    {registration.numberOfAccompanyingPerson ?
                      <span className="f6 db black-80">
                        <b>Number of accompanying person: </b>{registration.numberOfAccompanyingPerson}</span> : undefined}
                    {registration.abstract ?
                      <span className="f6 db black-80">
                        <b>Abstract: </b>{registration.abstract}</span> : undefined}
                  </div>
                  <div className="pl2 w-25-ns">
                    {registration.degree ?
                      <span className="f6 db black-80">
                        <b>Degree: </b>{registration.degree}</span> : undefined}
                    {registration.designation ?
                      <span className="f6 db black-80">
                        <b>Designation: </b>{registration.designation}</span> : undefined}
                    {registration.location ?
                      <span className="f6 db black-80">
                        <b>Location: </b>{registration.location}</span> : undefined}
                  </div>
                  <div className="pl2 w-25-ns">
                    {registration.phone ?
                      <span className="f6 db black-80"><b>Phone #: </b>{registration.phone}</span> : undefined}
                    {registration.faxNumber ?
                      <span className="f6 db black-80">
                        <b>Fax: </b>{registration.faxNumber}</span> : undefined}
                    {registration.particularAccompanyingPerson ?
                      <span className="f6 db black-80">
                        <b>Particular accompanying person: </b>{registration.particularAccompanyingPerson}</span> : undefined}
                  </div>
                </li>
              ))}
            </ul>
        }
      </div>
    </div>
  </div>
));

export const AdminPage = inject('store')(observer((props: { store?: typeof Store.Type }) => {
  props.store!.registrations.refresh();
  return <AdminPageComponent store={props.store!} />;
}));


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/apps/BCOMS/pages/Admin.tsx